import React, { useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as echarts from "echarts";

const TrendCell = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current);
      chart.setOption({
        grid: { left: 0, right: 0, top: 5, bottom: 5 },
        xAxis: {
          type: "category",
          show: true,
          data: data.map(point => point.name),
          axisLabel: { show: false }
        },
        yAxis: { type: "value", show: false },
        series: [
          {
            type: "line",
            data: data.map(point => point.value),
            smooth: true,
            lineStyle: { width: 1 },
            showSymbol: false,
            areaStyle: {},
          },
        ],
      });
    }
  }, [data]);

  return <div style={{ width: 100, height: 40 }} ref={chartRef}></div>;
};

const TrendTable = (props) => {
    
  return (
    <DataTable
      selectionMode
      tableStyle={{ minWidth: "50rem", padding: "0px" }}
      filterDisplay={props.dontshowMenu === undefined ? "menu" : ""}
      rowClassName={props.rowClassName}
      // globalFilter={globalFilter}
      value={props.data}
      dataKey={props.title}
      rows={5}
      paginator
      // rowsPerPageOptions={props.rowsPerPageOptions}
      emptyMessage={`No se encontraron registros`}
    >
      {props.columns.map((col, i) =>
        col.field === "tendencia" ? (
          <Column
            key={i}
            field={col.field !== undefined ? col.field : ""}
            header={col.header}
            body={(rowData) => <TrendCell data={[rowData.fecha ,rowData.tendencia]} />}
            // sortable={
            //   col.sortable !== undefined && col.sortable === true ? true : false
            // }
            style={{ width: props.width ? props.width : "auto" }}
          />
        ) : (
          <Column
            key={i}
            field={col.field !== undefined ? col.field : ""}
            header={col.header}
            filterMatchMode={col.filterMatchMode}
            body={col.body}
            sortable={
              col.sortable !== undefined && col.sortable === true ? true : false
            }
            // filter={col.filter !== undefined ? col.filter : true}
            style={{ width: props.width ? props.width : "auto" }}
          />
        )
      )}
      {props.actions.length > 0 &&
        props.actions.map((b, i) => {
          return (
            <Column
              key={i}
              body={(rowData) => {
                return <div className="flex">{b(rowData)}</div>;
              }}
              style={{ textAlign: "center", width: "6rem" }}
            />
          );
        })}
    </DataTable>
  );
};

export default TrendTable;
